import { Button, message, Upload } from "antd";
import React, { useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useGlobalModel from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { useBillCreateModel } from "./billCreateModel";
import { beService } from "@/views/base/be/beService";
import { orgService } from "@/views/base/org/orgService";
import { labelsType } from "@/views/cash/pay/cashPayModel";
import { CreateSupplierBillDrawer } from "./createSupplierBillDrawer";
import { CreateCustomerBillDrawer } from "./createCustomerBillDrawer";
import { importPropsConfig } from "@/utils/importFile";
import { dictService } from "@/views/base/dict/dictService";
import appService from "@/views/base/app/appService";
import { PageHeader } from './PageHeader'
import { BillDataTable } from "./DataTable";
import { UserTypeEnum } from "@/types/FmsEnums";

export const BillCreate = () => {

  const {
    setOrgDs,
    setBeDs,
    setAppDs,
    setPayMethodDs,
    setPayMethodLabels,
    billCustomerExport,
    createParterType,
    setCreateCustomerBillDrawerVisible,
    setCreateSupplierBillDrawerVisible,
    loadData,
    setCreateParterType,
    onCreateCustomerBill,
    onCreateSupplierBill,
  } = useBillCreateModel(model => [model.billSummaryData])

  const { getSelectedDict } = useGlobalModel(() => []);

  useEffect(() => {
    let obj: labelsType = {}
    appService.appDs({}).then(ds => setAppDs(ds));
    orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
    beService.beDs({}).then(ds => setBeDs(ds))
    getSelectedDict(DictCodeEnmu.SETTLE_TYPE).forEach(item => {
      obj[item.value] = item.label
    })
    dictService.accountTreeOne(DictCodeEnmu.PAY_METHOD).then(ds => setPayMethodDs(ds))
    setPayMethodLabels(obj);
    loadData({ pageNum: 1 }).then()
  }, []);


  // useEffect(() => {
  //   debugger
  //   if (createParterType) {
  //     setCreateCustomerBillDrawerVisible(true)
  //   }
  // }, [createParterType])




  const desc: IDescription[] = [
    // {
    //   label: "账单总额",
    //   value: billSummaryData?.totalBillAmount?.toFixed(2) ?? 0.00,
    //   color: DescriptionColorEnum.green
    // },
    // {
    //   label: "已核销总额",
    //   value: billSummaryData?.totalWriteoffAmount?.toFixed(2) ?? 0.00,
    //   color: DescriptionColorEnum.green
    // },
    // {
    //   label: "未核销总额",
    //   value: billSummaryData?.totalUnWriteoffAmount?.toFixed(2) ?? 0.00,
    //   color: DescriptionColorEnum.red
    // },
    // {
    //   label: "已开票总额",
    //   value: billSummaryData?.totalInvoiceAmount?.toFixed(2) ?? 0.00,
    //   color: DescriptionColorEnum.red
    // },
  ]

  const action = (
    <>
      {/* <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onWriteoff}
                >
                    核销
                </Button> */}
      {/* <YhAuth resCode={ResourceAuthEnum.BILL_C_EX}>
        <Button
          className="mr-5"
          type="link"
          shape="round"
          onClick={billCustomerExport}
        >
          导出
        </Button>
      </YhAuth> */}
      <YhAuth resCode={ResourceAuthEnum.BILL_C_EX}>
        <Button
          className="mr-5"
          type="link"
          shape="round"
          onClick={onCreateCustomerBill}
        >
          新增客户账单
        </Button>
      </YhAuth>
      <YhAuth resCode={ResourceAuthEnum.BILL_C_EX}>
        <Button
          className="mr-5"
          type="link"
          shape="round"
          onClick={onCreateSupplierBill}
        >
          新增供应商账单
        </Button>
      </YhAuth>
      <YhAuth resCode={ResourceAuthEnum.BILL_C_EX}>
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/bill/import`, () => loadData({ pageNum: 1 }).then())}>
          <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
      </YhAuth>

    </>
  );

  return (
    <>
      <PageHeader />
      <YhBox title={"账单列表"} descriptions={desc} action={action}>
        <BillDataTable />
      </YhBox>
      <CreateCustomerBillDrawer />
      <CreateSupplierBillDrawer />
    </>
  )
}